import { colors } from "../../Styles";

export function LifeNumber({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <polygon points="127.79 171.47 156.71 171.47 162.03 150.26 133.11 150.26 127.79 171.47"/>
      <path d="M245.39,65.12c-37.02-27.34-99.12,27.67-100.48,28.88-1.36-1.21-63.47-56.22-100.48-28.88-103.06,76.11,96.86,197,100.46,199.17v.03s.01,0,.03-.02c.02,0,.03.02.03.02v-.03c3.6-2.17,203.51-123.05,100.46-199.17ZM196.07,150.26h-19.38l-5.32,21.21h19.12l-2.02,13.84h-19.17l-5.9,25.96h-14.67l5.9-25.96h-28.92l-5.9,25.96h-14.66l5.9-25.96h-19.32l2.02-13.84h19.38l5.32-21.21h-19.12l2.02-13.84h19.17l5.9-25.97h14.66l-5.9,25.97h28.93l5.9-25.97h14.66l-5.9,25.97h19.32l-2.02,13.84Z"/>
    </svg>
  );
}
